// Components==============
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './index.module.scss';
// =========================

export default function Checkbox({ isSelected, background, opacity }) {
    return (
        <div
            styleName="wrapper"
            style={{
                backgroundColor: background || '#F1F0EA',
                opacity: opacity ? 0.4 : 1,
            }}
        >
            <FontAwesomeIcon
                icon={faCheck}
                style={{
                    color: isSelected
                        ? opacity
                            ? '#fff'
                            : '#1e265c'
                        : background || '#F1F0EA',
                }}
            />
        </div>
    );
}
